import { DateTime } from 'luxon'

import { getStatus } from '@/shared/config/missions'
import type { MissionWithProgress } from '@/types/mission'

import type { MissionUiStatus } from '../constants/status'

export const getMissionUiStatus = (
  mission: MissionWithProgress
): MissionUiStatus => {
  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  if (timeStatus?.slug === 'closed') return 'expired'
  if (timeStatus?.slug === 'soon') return 'locked'

  const submissionStatus = mission._progress?.status

  if (submissionStatus === 'approved' || mission._progress?.finished) {
    return 'success'
  }

  if (
    submissionStatus === 'pending' ||
    submissionStatus === 'refused' ||
    submissionStatus === 'awaiting_correction' ||
    mission._progress?.submitted
  ) {
    return 'progress'
  }

  return 'available'
}

export const isMissionEndingSoon = (
  mission: MissionWithProgress,
  withinHours = 24
): boolean => {
  if (!mission.end_at) return false

  const timeStatus = getStatus({
    start_at: mission.start_at,
    end_at: mission.end_at
  })

  if (timeStatus?.slug !== 'open') return false

  const endAt = DateTime.fromISO(mission.end_at)
  const now = DateTime.local()

  return endAt > now && endAt.diff(now, 'hours').hours <= withinHours
}

export const getMissionRewardScore = (mission: MissionWithProgress): number =>
  (mission.coin_reward ?? 0) * 2 + (mission.point_reward ?? 0)
